<template>
  <p class="text-gray-500 text-sm italic">
    <span class="text-red-500">*</span> -
    {{ lang === "mn" ? "Заавал бөглөх" : "Must be filled" }}
  </p>

  <div
    v-for="(category, index) in form.categories"
    :key="index"
    class="flex max-sm:flex-col items-center mt-5"
  >
    <div class="w-full sm:mr-10">
      <label
        >{{ lang === "mn" ? "Үндсэн ангилал:" : "Main category:"
        }}<span class="text-red-500">*</span></label
      >
      <select
        v-model="category.mainCategory"
        @change="filterSubCategories(category)"
        class="w-full border p-2"
        :class="
          errors.categories?.[index]?.mainCategory ? 'border-red-500' : ''
        "
        @input="clearCategoryError(index, 'mainCategory')"
      >
        <option disabled value="">
          {{ lang === "mn" ? "Үндсэн ангилал" : "All categories" }}
        </option>
        <option value="01">
          {{ lang === "mn" ? "Уул уурхайн компани" : "Mining Companies" }}
        </option>
        <option value="02">
          {{ lang === "mn" ? "Ханган нийлүүлэгч" : "Supplier Companies" }}
        </option>
        <option value="03">
          {{ lang === "mn" ? "Үйлчилгээ үзүүлэгч" : "Service Companies" }}
        </option>
        <option value="04">
          {{ lang === "mn" ? "Бусад" : "Other Companies" }}
        </option>
      </select>
    </div>

    <div class="w-full sm:mr-3">
      <label
        >{{ lang === "mn" ? "Дэд ангилал:" : "Sub category:"
        }}<span class="text-red-500">*</span></label
      >
      <select
        v-model="category.subCategory"
        class="w-full border p-2"
        :class="errors.categories?.[index]?.subCategory ? 'border-red-500' : ''"
        @input="clearCategoryError(index, 'subCategory')"
      >
        <option disabled value="">
          {{ lang === "mn" ? "Дэд ангилал" : "All sub-categories" }}
        </option>
        <option
          v-for="sub in category.subCategories"
          :key="sub.id"
          :value="sub.id"
        >
          {{ sub.name }}
        </option>
      </select>
    </div>

    <button
      v-if="form.categories.length > 1"
      @click="removeCategory(index)"
      class="text-red-500 text-xl mt-2"
    >
      -
    </button>
  </div>

  <button @click="addCategory" class="text-blue-500 text-sm mb-5 mt-2">
    <font-awesome-icon icon="fa-solid fa-plus" />
    {{ lang === "mn" ? "Ангилал нэмэх" : "Add Category" }}
  </button>

  <div class="flex max-sm:flex-col gap-5 mb-5 md:gap-10 w-full">
    <div class="w-full">
      <label for="nameMn"
        >{{
          lang === "mn"
            ? "Байгууллагын нэр /монголоор/:"
            : "Company Name by Mongolian:"
        }}<span class="text-red-500">*</span></label
      >
      <input
        id="nameMn"
        name="nameMn"
        type="text"
        placeholder="Байгууллагын нэр"
        class="w-full p-2 border"
        :class="errors.nameMn ? 'border-red-500' : ''"
        v-model="form.nameMn"
        @input="errors.nameMn = false"
      />
      <p v-if="errors.nameMn" class="text-red-500 text-sm mt-1">
        {{
          lang === "mn"
            ? "Энэ талбарыг бөглөнө үү."
            : "Please fill out this field."
        }}
      </p>
    </div>

    <div class="w-full">
      <label for="nameEn"
        >{{
          lang === "mn"
            ? "Байгууллагын нэр /англиар/:"
            : "Company Name by English:"
        }}<span class="text-red-500">*</span></label
      >
      <input
        id="nameEn"
        name="nameEn"
        type="text"
        placeholder="Company name"
        class="w-full p-2 border"
        :class="errors.nameEn ? 'border-red-500' : ''"
        v-model="form.nameEn"
        @input="errors.nameEn = false"
      />
      <p v-if="errors.nameEn" class="text-red-500 text-sm mt-1">
        {{
          lang === "mn"
            ? "Энэ талбарыг бөглөнө үү."
            : "Please fill out this field."
        }}
      </p>
    </div>
  </div>

  <div class="flex max-sm:flex-col gap-5 md:gap-10 w-full">
    <div class="w-full">
      <label for="registrationNumber"
        >{{
          lang === "mn"
            ? "Байгууллагын регистрийн дугаар:"
            : "Organization registration number:"
        }}<span class="text-red-500">*</span></label
      >
      <input
        id="registrationNumber"
        name="registrationNumber"
        type="text"
        :placeholder="lang === 'mn' ? 'Регистр' : 'Registration number'"
        class="w-full p-2 border"
        :class="errors.registrationNumber ? 'border-red-500' : ''"
        v-model="form.registrationNumber"
        @input="errors.registrationNumber = false"
      />
      <p v-if="errors.registrationNumber" class="text-red-500 text-sm mt-1">
        {{
          lang === "mn"
            ? "Энэ талбарыг бөглөнө үү."
            : "Please fill out this field."
        }}
      </p>
    </div>

    <div class="w-full"></div>
  </div>

  <div class="flex max-sm:flex-col justify-between gap-5 md:gap-10 mt-5">
    <div class="w-full">
      <label>{{ lang === "mn" ? "И-мэйл хаяг:" : "Email address:" }}</label>
      <div
        v-for="(email, index) in form.emails"
        :key="'email' + index"
        class="flex gap-2 mb-2"
      >
        <input
          v-model="form.emails[index]"
          type="email"
          class="w-full p-2 border"
          :placeholder="lang === 'mn' ? 'И-мэйл' : 'E-mail'"
        />
        <button
          v-if="form.emails.length > 1"
          @click="removeField('emails', index)"
          class="text-red-500"
        >
          -
        </button>
      </div>
      <button @click="addField('emails')" class="text-blue-500 text-sm">
        <font-awesome-icon icon="fa-solid fa-plus" />
        {{ lang === "mn" ? "И-мэйл нэмэх" : "Add Email" }}
      </button>
    </div>

    <div class="w-full">
      <label>{{ lang === "mn" ? "Утасны дугаар:" : "Phone number:" }}</label>
      <div
        v-for="(phone, index) in form.phones"
        :key="'phone' + index"
        class="flex gap-2 mb-2"
      >
        <input
          v-model="form.phones[index]"
          type="tel"
          class="w-full p-2 border"
          :placeholder="lang === 'mn' ? 'Утас' : 'Phone Number'"
        />
        <button
          v-if="form.phones.length > 1"
          @click="removeField('phones', index)"
          class="text-red-500"
        >
          -
        </button>
      </div>
      <button @click="addField('phones')" class="text-blue-500 text-sm">
        <font-awesome-icon icon="fa-solid fa-plus" />
        {{ lang === "mn" ? "Утасны дугаар нэмэх" : "Add Phone" }}
      </button>
    </div>
  </div>

  <div class="flex max-sm:flex-col justify-between gap-5 md:gap-10 my-5">
    <!-- Faxes -->
    <div class="w-full">
      <label>{{ lang === "mn" ? "Факс:" : "Fax:" }}</label>
      <div
        v-for="(fax, index) in form.faxes"
        :key="'fax' + index"
        class="flex gap-2 mb-2"
      >
        <input
          v-model="form.faxes[index]"
          type="tel"
          class="w-full p-2 border"
          :placeholder="lang === 'mn' ? 'Факс' : 'Fax'"
        />
        <button
          v-if="form.faxes.length > 1"
          @click="removeField('faxes', index)"
          class="text-red-500"
        >
          -
        </button>
      </div>
      <button @click="addField('faxes')" class="text-blue-500 text-sm">
        <font-awesome-icon icon="fa-solid fa-plus" />
        {{ lang === "mn" ? "Факс нэмэх" : "Add Fax" }}
      </button>
    </div>

    <!-- Websites -->
    <div class="w-full">
      <label>{{ lang === "mn" ? "Вэбсайт:" : "Website:" }}</label>
      <div
        v-for="(website, index) in form.websites"
        :key="'website' + index"
        class="flex gap-2 mb-2"
      >
        <input
          v-model="form.websites[index]"
          type="url"
          class="w-full p-2 border"
          :placeholder="lang === 'mn' ? 'Вэбсайт' : 'Website'"
        />
        <button
          v-if="form.websites.length > 1"
          @click="removeField('websites', index)"
          class="text-red-500"
        >
          -
        </button>
      </div>
      <button @click="addField('websites')" class="text-blue-500 text-sm">
        <font-awesome-icon icon="fa-solid fa-plus" />
        {{ lang === "mn" ? "Вэбсайт нэмэх" : "Add Website" }}
      </button>
    </div>
  </div>

  <div class="flex max-sm:flex-col my-5">
    <h4 class="w-[15rem]">Лого:<span class="text-red-500">*</span></h4>
    <div class="space-y-3 w-full">
      <div
        class="flex flex-col justify-center items-center"
        :class="mainImage ? 'w-1/3 object-contain' : 'h-40 w-40'"
      >
        <img
          :src="imageSrc"
          alt="image"
          :class="!mainImage ? 'w-14 h-14' : ''"
        />
        <span v-if="!mainImage" class="text-xs text-gray-500"
          >Зураг байхгүй байна</span
        >
      </div>
      <input
        type="file"
        class="w-full bg-white border p-2"
        :class="errors.logo ? 'border-red-500' : ''"
        @change="onImageChange"
        accept="image/jpeg, image/png"
        @input="errors.logo = false"
      />
      <p v-if="errors.logo" class="text-red-500 text-sm mt-1">
        {{
          lang === "mn"
            ? "Энэ талбарыг бөглөнө үү."
            : "Please fill out this field."
        }}
      </p>
    </div>
  </div>

  <label for="addressMn" class="mt-5">{{
    lang === "mn" ? "Хаяг /монголоор/:" : "Address by mongolian:"
  }}</label>
  <input
    id="addressMn"
    name="addressMn"
    type="text"
    placeholder="Хаяг"
    class="w-full p-2 border mb-5"
    v-model="form.addressMn"
  />

  <label for="addressEn">{{
    lang === "mn" ? "Хаяг /англиар/:" : "Address by english:"
  }}</label>
  <input
    id="addressEn"
    name="addressEn"
    type="text"
    placeholder="Address"
    class="w-full p-2 border mb-5"
    v-model="form.addressEn"
  />

  <label for="aboutMn" class="mt-5">{{
    lang === "mn"
      ? "Товч танилцуулга /монголоор/:"
      : "Introduction by mongolian:"
  }}</label>
  <textarea
    id="aboutMn"
    name="aboutMn"
    type="text"
    rows="6"
    placeholder="Танилцуулга"
    class="w-full p-2 border mb-5"
    v-model="form.aboutMn"
  >
  </textarea>

  <label for="aboutEn" class="mt-5">{{
    lang === "mn" ? "Товч танилцуулга /англиар/:" : "Introduction by english:"
  }}</label>
  <textarea
    id="aboutEn"
    name="aboutEn"
    type="text"
    rows="6"
    placeholder="Introduction"
    class="w-full p-2 border mb-20"
    v-model="form.aboutEn"
  >
  </textarea>
</template>

<script>
import clientYellowInstance from "@/lib/yellowClientInstance";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "YellowCompanyRegistration",
  props: {
    company: [Object, Array],
  },
  setup(props, { expose }) {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const subCategories = ref([]);
    const success = ref(null);
    const error = ref(null);
    const form = ref({
      categories: [{ mainCategory: "01", subCategory: "", subCategories: [] }],
      nameMn: "",
      nameEn: "",
      registrationNumber: "",
      emails: [""],
      phones: [""],
      faxes: [""],
      websites: [""],
      addressMn: "",
      addressEn: "",
      aboutMn: "",
      aboutEn: "",
    });

    // Main image
    const defaultImage = require("@/assets/svg/image-not-found-icon.svg");
    const imageSrc = ref(defaultImage);
    const mainImage = ref("");

    const onImageChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        imageSrc.value = URL.createObjectURL(file);
        mainImage.value = file;
      } else {
        imageSrc.value = defaultImage;
        mainImage.value = null;
      }
    };

    const fetchAllSubCategories = async () => {
      try {
        const res = await clientYellowInstance.get(
          `/categories?language=${lang.value}`
        );
        if (res.status === 200) {
          subCategories.value = res.data.subCategories;
          filterSubCategories(form.value.categories[0]);
        }
      } catch (err) {
        return err;
      }
    };

    onMounted(() => {
      fetchAllSubCategories();
      if (props.company) {
        form.value = {
          categories: props.company.categories,
          nameMn: props.company.nameMn,
          nameEn: props.company.nameEn,
          registrationNumber: props.company.registrationNumber,
          emails: props.company.emails,
          phones: props.company.phones,
          faxes: props.company.faxes,
          websites: props.company.websites,
          addressMn: props.company.addressMn,
          addressEn: props.company.addressEn,
          aboutMn: props.company.aboutMn,
          aboutEn: props.company.aboutEn,
        };
        imageSrc.value = props.company.mainImage;
        mainImage.value = props.company.mainImage;
      }
    });

    const addField = (field) => {
      form.value[field].push("");
    };

    const removeField = (field, index) => {
      form.value[field].splice(index, 1);
    };

    const addCategory = () => {
      const filteredSubCategories = subCategories.value.filter((sub) =>
        sub.category_code.startsWith("01")
      );

      form.value.categories.push({
        mainCategory: "01",
        subCategory: "",
        subCategories: filteredSubCategories,
      });
    };

    const removeCategory = (index) => {
      form.value.categories.splice(index, 1);
    };

    const filterSubCategories = (category) => {
      category.subCategory = "";

      category.subCategories = subCategories.value.filter((sub) =>
        sub.category_code.startsWith(category.mainCategory)
      );
    };

    const errors = ref({
      categories: { mainCategory: false, subCategory: false },
      nameMn: false,
      nameEn: false,
      registrationNumber: false,
      logo: false,
    });

    const clearCategoryError = (index, field) => {
      if (errors.value.categories && errors.value.categories[index]) {
        errors.value.categories[index][field] = false;
      }
    };

    const validateForm = () => {
      let isValid = true;
      const newErrors = {};

      if (!form.value.nameMn) {
        newErrors.nameMn = true;
        isValid = false;
      }

      if (!form.value.nameEn) {
        newErrors.nameEn = true;
        isValid = false;
      }

      if (!form.value.registrationNumber) {
        newErrors.registrationNumber = true;
        isValid = false;
      }

      if (!mainImage.value) {
        newErrors.logo = true;
        isValid = false;
      }

      form.value.categories.forEach((cat, index) => {
        if (!cat.mainCategory || !cat.subCategory) {
          isValid = false;

          if (!newErrors.categories) newErrors.categories = {};
          newErrors.categories[index] = {
            mainCategory: !cat.mainCategory,
            subCategory: !cat.subCategory,
          };
        }
      });

      errors.value = newErrors;
      return isValid;
    };

    expose({ validateForm, form, mainImage });

    return {
      lang,
      form,
      onImageChange,
      imageSrc,
      mainImage,
      success,
      error,
      subCategories,
      addField,
      removeField,
      addCategory,
      removeCategory,
      filterSubCategories,
      errors,
      clearCategoryError,
    };
  },
};
</script>
